import { render } from "./index.vue?vue&type=template&id=1421c7be"
import script from "./schedules.ts?vue&type=script&lang=js"
export * from "./schedules.ts?vue&type=script&lang=js"

import "./schedules.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script